import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { STALE_TIME } from '@/shared/constants/app/time.constant.ts';
import { inquiryApi } from './inquiry.api.ts';
import { inquiryKeys } from './inquiry.keys.ts';
import type { InquiryListParams } from '../inquiry.type.ts';

/** 문의 목록 (본인 문의 / 운영자=전체). */
export function useInquiryList(params: InquiryListParams) {
  return useQuery({
    queryKey: inquiryKeys.list(params),
    queryFn: () => inquiryApi.getList(params),
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME.SHORT,
  });
}

/** UserMenu의 1:1 문의 레드닷 표시 여부. */
export function useInquiryUserMenuNotification() {
  return useQuery({
    queryKey: inquiryKeys.userMenuNotification(),
    queryFn: inquiryApi.getUserMenuNotification,
    staleTime: STALE_TIME.SHORT,
  });
}

/** 문의 상세 (본문 + 답변 포함). */
export function useInquiryDetail(id: string | undefined) {
  return useQuery({
    queryKey: inquiryKeys.detail(id ?? ''),
    queryFn: () => inquiryApi.getDetail(id!),
    enabled: id !== undefined && id !== '',
    staleTime: STALE_TIME.SHORT,
  });
}
